import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_rhodium.png",
      alt: "Estratégias Rhodium",
    },
    title: "Automatize seus investimentos",

    // String ou array de strings
    text: "Nosso robô realiza a função de um trader com a vantagem de ser uma inteligência artificial, sendo capaz de realizar entradas mais assertivas através do cruzamento de dados e indicadores desenvolvidos e criados pelos nossos traders. Estamos sempre buscando novas formas de inovação e tecnologia para aplicá-las as necessidades dos clientes.",
    testimonial: {
      text: "Nosso objetivo é fazer seu dinheiro trabalhar para você e não ao contrário, para que tenha mais tempo para o que realmente importa",
      author: {
        name: "Thiago Ferreira, fundador e head de estratégias",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Estratégias Rhodium",
    heading: "Estratégias amplamente testadas e validadas",
    subtitle:
      "Conheça nossas estratégias, desenvolvidas por uma equipe de traders que realmente vivem do mercado financeiro.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo as estratégias Rhodium.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Rhodium Company",
    col1: [
      "Somos uma empresa de tecnologia e automação financeira.",
      "Desenvolvemos robôs que atuam no mercado financeiro. Automatizamos processos de investimentos no day trade e assim tiramos do investidor o peso de operar e transferimos para nossa inteligência artificial que simula milhares de cenários diferentes utilizando dados matemáticos e estatísticos, sem interferência do emocional humano.",
      "Somos uma equipe especializada em mercado financeiro, com traders experientes que realmente vivem da bolsa de valores. Sendo esse um dos nossos diferenciais na criação das estratégias.",
    ],
    col2: [
      "Nosso objetivo é facilitar a vida do investidor. Priorizamos o que você tem de mais precioso: o tempo.",
      "Com a tecnologia da Rhodium, seu dinheiro não fica parado. Fazemos ele trabalhar para você, e não contrário.",
    ],
  },

  stats: {
    title: "Os números da Rhodium",
    subtitle:
      "Nosso objetivo é facilitar a vida do investidor. Priorizamos o que você tem de mais precioso: O tempo.",
    data: [
      {
        value: "+10",
        description: "Anos de experiência",
      },
      {
        value: "5",
        description: "Anos de gerações de sinais",
      },
      {
        value: "+250M",
        description: "Teste realizados",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Vantagens de utilizar os robôs da Rhodium",
    // subtitle: "Veja quais as principais vantagens dos robôs da Quantic.",
    data: [
      {
        icon: iconsSet.lock_line,
        title: "Seguro",
        description:
          "Seu dinheiro não sai da corretora, protegido pelo FGC e livre de fidelidade, ou seja, você pode retirar seu dinheiro a qualquer momento.",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Chega de cursos",
        description:
          "Não necessita de estudo prévio a respeito do mercado ou atualização de notícias sobre economia mundial.",
      },
      {
        icon: iconsSet.growth,
        title: "Estratégias  simultâneas",
        description: "Pode operar mais de uma estratégia ao mesmo tempo",
      },
      {
        icon: iconsSet.clock,
        title: "Seu tempo é precioso",
        description:
          "O robô não demanda instalação ou controle constante, nossa inteligência artificial faz todo o trabalho por você",
      },
      {
        icon: iconsSet.favorite,
        title: "Livre de emoção",
        description:
          "Tiramos do investidor o peso de operar e transferimos para nossa inteligência artificial que simula milhares de cenários diferentes utilizando dados matemáticos e estatísticos, sem interferência do emocional humano",
      },
      {
        icon: iconsSet.check,
        title: "Validação",
        description:
          "Estratégias amplamente testadas e validadas por traders experientes que realmente vivem da bolsa de valores.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos e vantagens!",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
